import { createSelector } from "reselect";

const selectCredit = (state) => state.credit;

export const selectCreditActiveTab = createSelector(
  selectCredit,
  (credit) => credit.activeTab
);

export const selectCreditAccountDetailIsLoading = createSelector(
  selectCredit,
  (credit) => credit.accountDetail_isLoading
);

export const selectCreditTransactions = createSelector(selectCredit, (credit) =>
  credit.accountDetail ? credit.accountDetail.account_transactions : null
);
